import { z } from 'zod';
import type { TFunction } from 'i18next';

export function createRegisterSchema(t: TFunction) {
  return z
    .object({
      firstName: z
        .string()
        .min(1, t('validation.firstName_required')),
      lastName: z
        .string()
        .min(1, t('validation.lastName_required')),
      email: z
        .string()
        .min(1, t('validation.email_required'))
        .email(t('validation.email_invalid')),
      phone: z
        .string()
        .optional(),
      password: z
        .string()
        .min(8, t('validation.password_min'))
        .regex(/[a-zA-Z]/, t('validation.password_letter'))
        .regex(/[0-9]/, t('validation.password_number')),
      confirmPassword: z
        .string()
        .min(1, t('validation.confirm_password_required')),
      termsAccepted: z
        .boolean()
        .refine((val) => val === true, {
          message: t('validation.terms_required', 'Debes aceptar la política de privacidad para continuar'),
        }),
    })
    .refine((data) => data.password === data.confirmPassword, {
      message: t('validation.passwords_mismatch'),
      path: ['confirmPassword'],
    });
}

export type RegisterFormValues = z.infer<ReturnType<typeof createRegisterSchema>>;
